export default __webpack_public_path__ + "static/catering_1-9437ca04725b596a9b367f8d51cc1bbb.png";